import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ExpandedTooltip, Icon } from '@livable/saas-react-components';
import { Button, Typography, InputLabel, FormControl, OutlinedInput, InputAdornment, IconButton, Chip, TextField } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { useStore } from 'src/stores';
import useUpdateUtilityCredentialsBatchModalStyles from './styles';
export const ModalForm = observer(_ref => {
  let credentialData = _ref.credentialData,
    handleModalClose = _ref.handleModalClose,
    isSingleAction = _ref.isSingleAction;
  // const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const classes = useUpdateUtilityCredentialsBatchModalStyles();
  const SecurityQuestionGroupBlock = _ref2 => {
    let questionName = _ref2.questionName,
      answerName = _ref2.answerName,
      credentialSecurityQuestions = _ref2.credentialSecurityQuestions,
      index = _ref2.index,
      handleQuestionChanges = _ref2.handleQuestionChanges;
    const _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isShowHiddenQuestionGroup = _useState2[0],
      setIsShowHiddenQuestionGroup = _useState2[1];
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
      id: "question-".concat(index + 1),
      className: "".concat(classes.securityQuestionsInput),
      label: t('general.question') + ' ' + (index + 1),
      variant: "outlined",
      value: questionName,
      onChange: e => handleQuestionChanges(index, 'questionName', e.target.value)
    }), /*#__PURE__*/React.createElement(FormControl, {
      variant: "outlined",
      className: "".concat(classes.securityQuestionsInput, " ").concat((credentialSecurityQuestions === null || credentialSecurityQuestions === void 0 ? void 0 : credentialSecurityQuestions.length) <= 1 ? '' : classes.securityQuestionsInputAnswer)
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "Password"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "light",
      component: 'span'
    }, t('general.answer') + ' ' + (index + 1))), /*#__PURE__*/React.createElement(OutlinedInput, {
      id: "answer-".concat(index + 1),
      type: "showPassword",
      label: "answer-".concat(index + 1),
      variant: "filled",
      value: isShowHiddenQuestionGroup ? answerName : '••••••••••••',
      onFocus: event => {
        console.log('onFocus', event);
        if (!isShowHiddenQuestionGroup) setIsShowHiddenQuestionGroup(!isShowHiddenQuestionGroup);
      },
      onBlur: event => {
        console.log('onBlur', event);
        if (isShowHiddenQuestionGroup) setIsShowHiddenQuestionGroup(!isShowHiddenQuestionGroup);
      },
      onChange: e => handleQuestionChanges(index, 'answerName', e.target.value),
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "grey",
        title: 'Show/Hide',
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: () => {
          setIsShowHiddenQuestionGroup(!isShowHiddenQuestionGroup);
        }
      }, !isShowHiddenQuestionGroup ? /*#__PURE__*/React.createElement(Icon, {
        type: "show-eye-on"
      }) : /*#__PURE__*/React.createElement(Icon, {
        type: "show-eye-off"
      }))))
    })));
  };
  const CredentialItemBlock = _ref3 => {
    let credentialDatum = _ref3.credentialDatum;
    const _useState3 = useState(credentialDatum === null || credentialDatum === void 0 ? void 0 : credentialDatum.website),
      _useState4 = _slicedToArray(_useState3, 2),
      credentialWebsite = _useState4[0],
      setCredentialWebsite = _useState4[1];
    const _useState5 = useState(credentialDatum === null || credentialDatum === void 0 ? void 0 : credentialDatum.username),
      _useState6 = _slicedToArray(_useState5, 2),
      credentialUsername = _useState6[0],
      setCredentialUsername = _useState6[1];
    const _useState7 = useState(credentialDatum === null || credentialDatum === void 0 ? void 0 : credentialDatum.password),
      _useState8 = _slicedToArray(_useState7, 2),
      credentialUserPassword = _useState8[0],
      setCredentialUserPassword = _useState8[1];
    const _useState9 = useState(false),
      _useState0 = _slicedToArray(_useState9, 2),
      isShowHiddenPassword = _useState0[0],
      setIsShowHiddenPassword = _useState0[1];
    const _useState1 = useState((credentialDatum === null || credentialDatum === void 0 ? void 0 : credentialDatum.questions) || [{
        questionName: '',
        answerName: ''
      }]),
      _useState10 = _slicedToArray(_useState1, 2),
      credentialSecurityQuestions = _useState10[0],
      setCredentialSecurityQuestions = _useState10[1];
    const handleQuestionChanges = (index, field, value) => {
      const credentialSecurityQuestionsInt = [...credentialSecurityQuestions];
      credentialSecurityQuestionsInt[index][field] = value;
      setCredentialSecurityQuestions([...credentialSecurityQuestionsInt]);
    };
    const addNewSecurityQuestionSet = () => {
      setCredentialSecurityQuestions([...credentialSecurityQuestions, {
        questionName: '',
        answerName: ''
      }]);
    };
    const removeSecurityQuestionSet = index => {
      credentialSecurityQuestions.splice(index, 1);
      setCredentialSecurityQuestions([...credentialSecurityQuestions]);
    };
    return /*#__PURE__*/React.createElement("div", {
      className: classes.credentialFormContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.credentialFormHeader)
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, t("".concat(credentialDatum.utilityTypeName, ": ").concat(credentialDatum.utilityProviderName))), !isSingleAction && /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      color: 'light'
    }, t("".concat(credentialDatum.propertyAddress))))), /*#__PURE__*/React.createElement(Chip, {
      className: "".concat(classes.credentialsWarning),
      label: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
        variant: "h5",
        color: 'light',
        component: 'span'
      }, t('Issue type:')), ' ', /*#__PURE__*/React.createElement(Typography, {
        variant: "h5",
        component: 'span'
      }, t("".concat(credentialDatum === null || credentialDatum === void 0 ? void 0 : credentialDatum.credentialIssueType)))),
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "info"
      }),
      variant: "warning"
    }), /*#__PURE__*/React.createElement(TextField, {
      className: "".concat(classes.itemGeneralSpacing),
      label: t('add_new_property_flow.auto_billing_management_service_website'),
      variant: "outlined",
      fullWidth: true,
      value: credentialWebsite,
      onChange: e => setCredentialWebsite(e.target.value)
    }), /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.itemGeneralSpacing, " ").concat(classes.pairValueContainer)
    }, /*#__PURE__*/React.createElement(TextField, {
      className: "".concat(classes.credentialsInput),
      label: t('general.username'),
      variant: "outlined",
      value: credentialUsername,
      onChange: e => setCredentialUsername(e.target.value)
    }), /*#__PURE__*/React.createElement(FormControl, {
      variant: "outlined",
      className: "".concat(classes.credentialsInput)
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "Password"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "light",
      component: 'span'
    }, "Password")), /*#__PURE__*/React.createElement(OutlinedInput, {
      id: "Password",
      type: "showPassword",
      label: "Password",
      variant: "filled",
      value: isShowHiddenPassword ? credentialUserPassword : '••••••••••••',
      onChange: e => setCredentialUserPassword(e.target.value),
      onFocus: event => {
        console.log('onFocus', event);
        if (!isShowHiddenPassword) setIsShowHiddenPassword(!isShowHiddenPassword);
      },
      onBlur: event => {
        console.log('onBlur', event);
        if (isShowHiddenPassword) setIsShowHiddenPassword(!isShowHiddenPassword);
      },
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "grey",
        title: 'Show/Hide',
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: () => {
          console.log('Show hidden');
          setIsShowHiddenPassword(!isShowHiddenPassword);
        }
      }, !isShowHiddenPassword ? /*#__PURE__*/React.createElement(Icon, {
        type: "show-eye-on"
      }) : /*#__PURE__*/React.createElement(Icon, {
        type: "show-eye-off"
      }))))
    }))), !!(credentialSecurityQuestions !== null && credentialSecurityQuestions !== void 0 && credentialSecurityQuestions.length) && credentialSecurityQuestions.map((i, index) => {
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.itemGeneralSpacing, "  ").concat(classes.pairValueContainer),
        key: index
      }, /*#__PURE__*/React.createElement(SecurityQuestionGroupBlock, {
        questionName: i.questionName,
        answerName: i.answerName,
        credentialSecurityQuestions: credentialSecurityQuestions,
        index: index,
        handleQuestionChanges: handleQuestionChanges
      }), (credentialSecurityQuestions === null || credentialSecurityQuestions === void 0 ? void 0 : credentialSecurityQuestions.length) > 1 && /*#__PURE__*/React.createElement(Button, {
        id: "remove-answer-group-".concat(index + 1),
        className: "".concat(classes.securityQuestionsDeleteBtn),
        variant: "actionIcon",
        size: 'large',
        onClick: () => removeSecurityQuestionSet(index),
        'custom-attribute': '416-update-utility-credentials-batch-modal'
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "trash"
      })));
    }), /*#__PURE__*/React.createElement(Button, {
      className: "".concat(classes.itemGeneralSpacing),
      variant: "actionIcon",
      onClick: addNewSecurityQuestionSet,
      'custom-attribute': '417-update-utility-credentials-batch-modal'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "plus"
    }), /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, t('add_new_property_flow.auto_billing_bill_add_security_questions'))));
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.modalContent
  }, credentialData === null || credentialData === void 0 ? void 0 : credentialData.map((credential, index) => {
    return /*#__PURE__*/React.createElement(CredentialItemBlock, {
      credentialDatum: credential,
      key: index
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose,
    'custom-attribute': '418-update-utility-credentials-batch-modal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    disabled: false,
    onClick: () => {
      console.log('Save clicked');
      handleModalClose();
    },
    'custom-attribute': '419-update-utility-credentials-batch-modal'
  }, t('add_new_property_flow.save_and_close')))))));
});